import { render, staticRenderFns } from "./hotelMsgReleaseInfo.vue?vue&type=template&id=00b78855&scoped=true"
import script from "./hotelMsgReleaseInfo.vue?vue&type=script&lang=js"
export * from "./hotelMsgReleaseInfo.vue?vue&type=script&lang=js"
import style0 from "./hotelMsgReleaseInfo.vue?vue&type=style&index=0&id=00b78855&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b78855",
  null
  
)

export default component.exports